// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderProvider,
    ProviderProviderSortType,
    SupportCreateProviderPayload,
    SupportProvider,
    SupportProviderSortType,
    SupportReplaceProviderPayload,
    SupportUpdateProviderPayload,
    SupportCreateProviderPayloadToJSON,
    SupportReplaceProviderPayloadToJSON,
    SupportUpdateProviderPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderProviderFromJSON,
    SupportProviderFromJSON,
} from '../models';

export interface CreateSupportProviderRequest {
    supportCreateProviderPayload: SupportCreateProviderPayload;
}

export interface DisableSupportProviderRequest {
    id: string;
}

export interface GetProviderProviderRequest {
    id: string;
}

export interface GetSupportProviderRequest {
    id: string;
}

export interface ListProviderProvidersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderProvidersOrderEnum>;
    filterCreated?: Array<string>;
    filterOrganization?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterNpi?: Array<string>;
    filterEin?: Array<string>;
    filterSsn?: Array<string>;
    filterPtan?: Array<string>;
    filterLicense?: Array<string>;
    filterWcb?: Array<string>;
    filterOther?: Array<string>;
    filterEmail?: Array<string>;
    filterPhone?: Array<string>;
    filterFax?: Array<string>;
    filterProviderType?: Array<string>;
    sort?: Array<ProviderProviderSortType>;
}

export interface ListSupportProvidersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportProvidersOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterOrganization?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterNpi?: Array<string>;
    filterEin?: Array<string>;
    filterSsn?: Array<string>;
    filterPtan?: Array<string>;
    filterLicense?: Array<string>;
    filterWcb?: Array<string>;
    filterOther?: Array<string>;
    filterEmail?: Array<string>;
    filterPhone?: Array<string>;
    filterFax?: Array<string>;
    filterProviderType?: Array<string>;
    filterChargemasterId?: Array<string>;
    filterFirstLast?: Array<string>;
    sort?: Array<SupportProviderSortType>;
}

export interface ReplaceSupportProviderRequest {
    supportReplaceProviderPayload: SupportReplaceProviderPayload;
}

export interface UpdateSupportProviderRequest {
    id: string;
    supportUpdateProviderPayload: SupportUpdateProviderPayload;
}

/**
 * no description
 */
export class ProviderApi extends runtime.BaseAPI {

    /**
     * Creates a provider
     * Create a provider
     */
    async createSupportProviderRaw(requestParameters: CreateSupportProviderRequest): Promise<runtime.ApiResponse<SupportProvider>> {
        if (requestParameters['supportCreateProviderPayload'] === null || requestParameters['supportCreateProviderPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateProviderPayload','Required parameter requestParameters.supportCreateProviderPayload was null or undefined when calling createSupportProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:provider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/provider`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateProviderPayloadToJSON(requestParameters['supportCreateProviderPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportProviderFromJSON(jsonValue));
    }

    /**
     * Creates a provider
     * Create a provider
     */
    async createSupportProvider(requestParameters: CreateSupportProviderRequest): Promise<SupportProvider> {
        const response = await this.createSupportProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a provider
     * Disable a provider
     */
    async disableSupportProviderRaw(requestParameters: DisableSupportProviderRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:provider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/provider/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a provider
     * Disable a provider
     */
    async disableSupportProvider(requestParameters: DisableSupportProviderRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a provider
     * Get a provider
     */
    async getProviderProviderRaw(requestParameters: GetProviderProviderRequest): Promise<runtime.ApiResponse<ProviderProvider>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:provider"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/provider/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderProviderFromJSON(jsonValue));
    }

    /**
     * Gets a provider
     * Get a provider
     */
    async getProviderProvider(requestParameters: GetProviderProviderRequest): Promise<ProviderProvider> {
        const response = await this.getProviderProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a provider
     * Get a provider
     */
    async getSupportProviderRaw(requestParameters: GetSupportProviderRequest): Promise<runtime.ApiResponse<SupportProvider>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:provider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/provider/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportProviderFromJSON(jsonValue));
    }

    /**
     * Gets a provider
     * Get a provider
     */
    async getSupportProvider(requestParameters: GetSupportProviderRequest): Promise<SupportProvider> {
        const response = await this.getSupportProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of providers
     * Get a list of providers
     */
    async listProviderProvidersRaw(requestParameters: ListProviderProvidersRequest): Promise<runtime.ApiResponse<Array<ProviderProvider>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterOrganization) {
            queryParameters['filterOrganization'] = requestParameters.filterOrganization;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterNpi) {
            queryParameters['filterNpi'] = requestParameters.filterNpi;
        }

        if (requestParameters.filterEin) {
            queryParameters['filterEin'] = requestParameters.filterEin;
        }

        if (requestParameters.filterSsn) {
            queryParameters['filterSsn'] = requestParameters.filterSsn;
        }

        if (requestParameters.filterPtan) {
            queryParameters['filterPtan'] = requestParameters.filterPtan;
        }

        if (requestParameters.filterLicense) {
            queryParameters['filterLicense'] = requestParameters.filterLicense;
        }

        if (requestParameters.filterWcb) {
            queryParameters['filterWcb'] = requestParameters.filterWcb;
        }

        if (requestParameters.filterOther) {
            queryParameters['filterOther'] = requestParameters.filterOther;
        }

        if (requestParameters.filterEmail) {
            queryParameters['filterEmail'] = requestParameters.filterEmail;
        }

        if (requestParameters.filterPhone) {
            queryParameters['filterPhone'] = requestParameters.filterPhone;
        }

        if (requestParameters.filterFax) {
            queryParameters['filterFax'] = requestParameters.filterFax;
        }

        if (requestParameters.filterProviderType) {
            queryParameters['filterProviderType'] = requestParameters.filterProviderType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:provider"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/provider`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderProviderFromJSON));
    }

    /**
     * Gets a list of providers
     * Get a list of providers
     */
    async listProviderProviders(requestParameters: ListProviderProvidersRequest): Promise<Array<ProviderProvider>> {
        const response = await this.listProviderProvidersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of providers
     * Get a list of providers
     */
    async listSupportProvidersRaw(requestParameters: ListSupportProvidersRequest): Promise<runtime.ApiResponse<Array<SupportProvider>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterOrganization) {
            queryParameters['filterOrganization'] = requestParameters.filterOrganization;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterNpi) {
            queryParameters['filterNpi'] = requestParameters.filterNpi;
        }

        if (requestParameters.filterEin) {
            queryParameters['filterEin'] = requestParameters.filterEin;
        }

        if (requestParameters.filterSsn) {
            queryParameters['filterSsn'] = requestParameters.filterSsn;
        }

        if (requestParameters.filterPtan) {
            queryParameters['filterPtan'] = requestParameters.filterPtan;
        }

        if (requestParameters.filterLicense) {
            queryParameters['filterLicense'] = requestParameters.filterLicense;
        }

        if (requestParameters.filterWcb) {
            queryParameters['filterWcb'] = requestParameters.filterWcb;
        }

        if (requestParameters.filterOther) {
            queryParameters['filterOther'] = requestParameters.filterOther;
        }

        if (requestParameters.filterEmail) {
            queryParameters['filterEmail'] = requestParameters.filterEmail;
        }

        if (requestParameters.filterPhone) {
            queryParameters['filterPhone'] = requestParameters.filterPhone;
        }

        if (requestParameters.filterFax) {
            queryParameters['filterFax'] = requestParameters.filterFax;
        }

        if (requestParameters.filterProviderType) {
            queryParameters['filterProviderType'] = requestParameters.filterProviderType;
        }

        if (requestParameters.filterChargemasterId) {
            queryParameters['filterChargemasterId'] = requestParameters.filterChargemasterId;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:provider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/provider`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportProviderFromJSON));
    }

    /**
     * Gets a list of providers
     * Get a list of providers
     */
    async listSupportProviders(requestParameters: ListSupportProvidersRequest): Promise<Array<SupportProvider>> {
        const response = await this.listSupportProvidersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a provider
     * Replace a provider
     */
    async replaceSupportProviderRaw(requestParameters: ReplaceSupportProviderRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceProviderPayload'] === null || requestParameters['supportReplaceProviderPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceProviderPayload','Required parameter requestParameters.supportReplaceProviderPayload was null or undefined when calling replaceSupportProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:provider", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/provider/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceProviderPayloadToJSON(requestParameters['supportReplaceProviderPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a provider
     * Replace a provider
     */
    async replaceSupportProvider(requestParameters: ReplaceSupportProviderRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a provider
     * Update a provider
     */
    async updateSupportProviderRaw(requestParameters: UpdateSupportProviderRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportProvider.');
        }

        if (requestParameters['supportUpdateProviderPayload'] === null || requestParameters['supportUpdateProviderPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateProviderPayload','Required parameter requestParameters.supportUpdateProviderPayload was null or undefined when calling updateSupportProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:provider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/provider/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateProviderPayloadToJSON(requestParameters['supportUpdateProviderPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a provider
     * Update a provider
     */
    async updateSupportProvider(requestParameters: UpdateSupportProviderRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportProviderRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderProvidersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportProvidersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
